// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"240":"workshop-edit-job","482":"group-job","494":"workshop-edit-jon","984":"workshop"}[chunkId] || chunkId) + "-legacy." + {"0":"0f2b2cdb","240":"5729203a","482":"26e1d3ed","494":"6db78bb1","561":"5b8f6e46","647":"edaa4a03","984":"4a7feaaa"}[chunkId] + ".js";
};